import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/food-option-list"

export const getsFoodOptionList = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createFoodOptionList = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateFoodOptionList = async (optionListId, data) => {
  const response = await farasod.patch(`${endpoint}/${optionListId}`, data)

  return response.data
}

export const deleteFoodOptionList = async optionListId => {
  const response = await farasod.delete(`${endpoint}/${optionListId}`)

  return response.data
}